import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class TipoOcorrencia implements Construtor<TipoOcorrencia> {
  public idTipoOcorrencia: number;
  public descricaoTipoOcorrencia: string;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof TipoOcorrencia) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  get obterIdTipoOcorrencia(): number {
    return this.idTipoOcorrencia;
  }

  set IdTipoOcorrencia(idTipoOcorrencia: any) {
    this.idTipoOcorrencia = idTipoOcorrencia;
  }

  get obterDescricaoTipoOcorrencia(): string {
    return this.descricaoTipoOcorrencia;
  }

  set DescricaoTipoOcorrencia(descricaoTipoOcorrencia) {
    this.descricaoTipoOcorrencia = StringValidacao.copiarStringValida(descricaoTipoOcorrencia);
  }

  copyObject(tipoOcorrencia: TipoOcorrencia): void {
    this.idTipoOcorrencia = tipoOcorrencia.obterIdTipoOcorrencia;
    this.descricaoTipoOcorrencia = tipoOcorrencia.obterDescricaoTipoOcorrencia;
  }

  parseFromJson(tipoOcorrencia: any): void {
    this.IdTipoOcorrencia = tipoOcorrencia.idTipoOcorrencia;
    this.DescricaoTipoOcorrencia = tipoOcorrencia.descricaoTipoOcorrencia;
  }

  modeloCompleto(): boolean {
    return this.descricaoTipoOcorrencia !== undefined;
  }

  getNewInstance(object?: any): TipoOcorrencia {
    return new TipoOcorrencia(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/tipo-ocorrencia.ts